import { LocalStorage } from 'quasar'
import { dateSqlDateTime } from 'src/helpers'
import getEnv from 'src/getEnv'

export function digitGroup (val, decimal = 2) {
  let _val = ''
  val = [0, '0', '0.00', '0.000', '0.0000'].includes(val) ? '0' : parseFloat(val)
  if (val && val !== '') {
    _val = val % 1 === 0
      ? val.toString()
      : val.toFixed(decimal).toString().replace('.', ',')
    _val = _val.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
  }
  return _val
}

export function isFloatFixed (val, decimal = 1) {
  // return Number(val).toFixed(decimal).replace('.0', '')
  return Number(val).toFixed(decimal)
}

export function isLiteralObject (a) {
  return (!!a) && (a.constructor === Object)
}

export function isLiteralFile (a) {
  return typeof a === 'object' && a?.constructor === File
}

export function filterFromStorage (pageName, options) {
  const {
    returnJoin = false,
    formatFilter = true,
    numberAsBoolean = false
  } = options

  const storage = LocalStorage.getItem('filter:' + pageName) || {}
  const filter = {}

  Object.keys(storage).forEach((item) => {
    if (storage[item] !== null && storage[item].length) {
      // TEMPORARY SOLUTION UNTIL BACKEND AND FRONTEND MADE AN AGREEMENT
      const key = formatFilter ? `filter[${item}]` : item
      switch (true) {
        case storage[item] === 0 || storage[item] === 1:
          filter[key] = numberAsBoolean ? Boolean(storage[item]) : storage[item]
          break

        case Array.isArray(storage[item]):
        case isLiteralObject(storage[item]) && Object.keys(storage[item]).length:
        default:
          filter[key] = storage[item]
      }
    }
  })

  if (returnJoin) {
    return Object.entries(filter)?.map(item => item.join('=')).join('&')
  } else {
    return filter
  }
}

export function setActiveMenu (routeName) {
  const routeTrime = routeName?.replace(/\s/g, '').toLowerCase()

  const drawer = document.querySelector('.drawer-nav')
  const selectedDrawer = drawer.querySelector(`[data-active-menu="${routeTrime}"]`)

  if (drawer.querySelectorAll(`[data-active-menu="${routeTrime}"]`).length) {
    drawer.querySelectorAll('[data-active-menu]').forEach(menu => menu.classList.remove('menu-active'))
    drawer.querySelectorAll('.q-expansion-item').forEach(item => item.classList.remove('expansion-active'))

    setTimeout(() => {
      selectedDrawer.classList.add('menu-active')

      const parent = selectedDrawer.closest('.q-expansion-item')
      if (parent) parent.classList.add('expansion-active')
    }, 50)
  }
}

export function checkFilterStorage (options, that) {
  const storageName = options?.storageName || `filter:${that.$route.name}`
  const filterResponse = LocalStorage.getItem(storageName) || {}

  const isLiteralObject = function (a) {
    return (!!a) && (a.constructor === Object)
  }

  const checkEmpty = Object.keys(filterResponse).find(item => {
    let check = false
    if (filterResponse[item] !== null) {
      switch (true) {
        case Array.isArray(filterResponse[item]):
          if (filterResponse[item].length) {
            check = true
          }
          break

        case isLiteralObject(filterResponse[item]):
          if (Object.keys(filterResponse[item]).length) {
            check = true
          }
          break

        default:
          check = true
      }
    }

    return check
  })

  return checkEmpty && checkEmpty !== false
}

export function deepMerge (...objects) {
  const isObject = obj => obj && typeof obj === 'object'

  return objects.reduce((prev, obj) => {
    Object.keys(obj).forEach(key => {
      const pVal = prev[key]
      const oVal = obj[key]

      if (Array.isArray(pVal) && Array.isArray(oVal)) {
        prev[key] = pVal.concat(...oVal)
      } else if (isObject(pVal) && isObject(oVal)) {
        prev[key] = deepMerge(pVal, oVal)
      } else {
        prev[key] = oVal
      }
    })

    return prev
  }, {})
}

export function isURL (str) {
  const urlPattern = /^(http|https):\/\/[\w-]+(\.[\w-]+)+([\w-.,@?^=%&:/~+#]*[\w-@?^=%&/~+#])?$/
  return urlPattern.test(str)
}

export function getFileSize (fileSize = 0) {
  const fileSizeInKB = fileSize / 1024
  const fileSizeInMB = fileSizeInKB / 1024

  if (fileSizeInMB >= 1) {
    return fileSizeInMB.toFixed(2) + ' MB'
  } else {
    return fileSizeInKB.toFixed(2) + ' KB'
  }
}

export function getFileMeta (file) {
  if (!file || file === null) return

  const isLiteralFile = typeof file === 'object' && file.constructor === File
  let name, type
  let size = 0

  if (isURL(file)) {
    const urlWithoutQueryString = file.split(/[#?]/)[0]
    name = urlWithoutQueryString.substring(urlWithoutQueryString.lastIndexOf('/') + 1)
    type = name.substring(name.lastIndexOf('.') + 1)
  }

  if (typeof file === 'string' && file?.split('.')?.length && !isURL(file)) {
    name = file.substring(0, file.lastIndexOf('.'))
    type = file.substring(file.lastIndexOf('.') + 1)
  }

  if (isLiteralFile) {
    name = file.name.substring(file.name.lastIndexOf('/') + 1)
    type = name.substring(name.lastIndexOf('.') + 1)
    size = file.size
  }

  return {
    name,
    type,
    size,
    humanFileSize: getFileSize(size)
  }
}

export function formDataAppend (formData, key, value) {
  if (value) formData.append(key, value)
}

export function checkUrlFileType (url, type = 'image') {
  url = url.split(/[#?]/)[0].split('.').pop().trim()

  let test
  if (type === 'image') {
    test = (url.match(/(jpeg|jpg|gif|png|webp)$/) != null)
  }
  return test
}

export function isBase64 (str) {
  if (!str || (str && (str === '' || str.trim() === ''))) { return false }
  try {
    return str.match(/[^:/]\w+(?=[;,])/)[0]
  } catch (error) {
    return false
  }
}

export function autoDownloadDocument (blob, options) {
  const {
    preTitle = 'document',
    ext = 'pdf'
  } = options

  const url = window.URL.createObjectURL(new Blob([blob]))
  const link = document.createElement('a')
  link.href = url
  link.setAttribute(
    'download',
    `${preTitle}_${dateSqlDateTime(
      new Date(),
      '_',
      '-'
    )}.${ext}`
  )
  document.body.appendChild(link)
  link.click()
  link.parentNode.removeChild(link)
}

export function setTaxValue (customerType) {
  return {
    BUSINESS: 23,
    RETAIL: 21
  }[customerType] || null
}

export function thumbor ({ url, format = 'webp', width, height, quality = 80, size = 'fit-in', useCdn = false }) {
  const hasExplicitSize = typeof width === 'number' && typeof height === 'number' ? `${width}x${height}/` : ''
  const baseThumborUrl = `${getEnv('THUMBOR_URL')}/unsafe/${size}/${hasExplicitSize}filters:format(${format}):quality(${quality})`

  return `${baseThumborUrl}/${url}`
}

export function ifElse (condition, trueVal, falseVal) {
  return condition ? trueVal : falseVal
}

export { default as formatCash } from './formatCash'
export * from './date'
export * from './text'
export * from './data'
export * from './validation'
